import template	from "./dialog-image.html";
import css		from "./dialog-image.css";

import Dialog	from "dialog";
import JSONRPC  from "json-rpc";
import sleep 	from "sleep";


class ImageDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-image", ImageDialog);
  }
  constructor() {
    super();

    window.imageServer = new JSONRPC();
    window.imageServer.connect("imagecapture/server.jss");
    window.imageServer.onopen = function() { console.log("websocket open"); };


    this.show();
    this.init();
  }
  buttonClose_click() {
    this.close();
    window.imageServer.close();
  }
  async init() {
    try {
      console.log("init");
      await sleep(100);
      console.log("rcall");
      var url = await imageServer.rcall("RM_getimage");
      console.log("update");
      this.image.style.backgroundPosition = `center center`;
      this.image.style.backgroundRepeat = `no-repeat`;
      this.image.style.backgroundImage = `url('${url}')`;
      this.image.style.backgroundSize = `100% 100%`;
      console.log("done");
    }catch(e) {
      console.error(e.message);
    }
  }
}

ImageDialog.constructor();

export default ImageDialog;